import { GenIcon } from '../helpers/IconBase.es.js';

const LinkOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M10.3333 12.8332C10.7936 12.8332 11.1667 12.4601 11.1667 11.9999C11.1667 10.6216 12.2883 9.49991 13.6666 9.49991H17.8333C19.2116 9.49991 20.3333 10.6216 20.3333 11.9999C20.3333 13.3782 19.2116 14.4999 17.8333 14.4999L16.3333 14.5C15.8731 14.5 15.5 14.8731 15.5 15.3333C15.5 15.7935 15.8731 16.1665 16.3333 16.1665H17.8333C20.1308 16.1665 21.9999 14.2974 21.9999 11.9999C21.9999 9.70241 20.1308 7.83325 17.8333 7.83325H13.6666C11.3692 7.83325 9.5 9.70241 9.5 11.9999C9.5 12.4601 9.87311 12.8332 10.3333 12.8332Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.6667 11.1665C13.2075 11.1665 12.8333 11.5 12.8333 11.9999C12.8333 13.3782 11.7117 14.4998 10.3334 14.4998L6.16671 14.4998C4.78839 14.4998 3.66672 13.3782 3.66672 11.9999C3.66672 10.6215 4.78838 9.49987 6.16671 9.49987L7.66667 9.49987C8.12691 9.49987 8.5 9.12678 8.5 8.66654C8.5 8.20631 8.12691 7.83321 7.66667 7.83321L6.16671 7.83321C3.86922 7.83321 2.00007 9.70237 2.00007 11.9999C2.00007 14.2973 3.86922 16.1665 6.16671 16.1665L10.3334 16.1665C12.6308 16.1665 14.5 14.2973 14.5 11.9999C14.5 11.5396 14.1269 11.1665 13.6667 11.1665Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { LinkOutlined };
